import { LISTAR_CENTRO_DE_CUSTOS, LISTAR_CENTRO_DE_CUSTO_SELECIONADO } from './mutation-types'

import CentroDeCustoHttpService from '../_services/CentroDeCustoHttpService'

export default {
  listarCentroDeCustos: async ({ commit }) => {
    try {
      const response = await CentroDeCustoHttpService.getCentroDeCustos()
      commit(LISTAR_CENTRO_DE_CUSTOS, response.data)
    } catch (e) {
      console.log(e)
    }
  },
  listarCentroDeCustosSelecionado: async ({ commit }, _id) => {
    try {
      const response = await CentroDeCustoHttpService.getCentroDeCusto(_id)
      commit(LISTAR_CENTRO_DE_CUSTO_SELECIONADO, response.data)
    } catch (e) {
      console.log(e)
    }
  },
}
